module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/85ba8d8493db6a87cd9b0010cfe09400.png";